import classNames from 'classnames'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

import appDownEvent from '@/utils/gaEvents/appDownEvent'

import Shared from '@/shared'
import Button from '@/shared/components/button/Button'
import { Tint } from '@/shared/components/typography'
import store from '@/shared/states'

const Footer = () => {
  const { isParkinglotRefund, isOnSiteRefund } = store.useRefundStore()
  const { myTicketData } = store.useMyTicketStore()
  const pathname = usePathname()
  const linkBaseUrl = process.env.NEXT_PUBLIC_PAGE_POLICY_HOST || ''
  const userGuideURL = process.env.NEXT_PUBLIC_PAGE_USERGUIDE_HOST || ''

  const handleClickAppDownload = () => {
    let screenName: 'parkinglotdetail' | 'ticketdetail' | 'myticketdetail' | '' = ''
    if (pathname.startsWith('/p')) {
      screenName = 'parkinglotdetail'
    } else if (pathname.startsWith('/t')) {
      screenName = 'ticketdetail'
    } else if (pathname.startsWith('/my-ticket')) {
      screenName = 'myticketdetail'
    }

    appDownEvent.onClickAppDownButton(`${process.env.NEXT_PUBLIC_WEBAPP_HOST}${pathname}`)

    window.open(`https://l.modu.kr/main?${Shared.Utils.makeUtmTagWhenAppDownClick(screenName)}`, '_blank')
  }
  return (
    <div
      className={classNames('bg-gray-020 px-4 py-6', [
        myTicketData && myTicketData.ticket.refunds.length > 0 && (isParkinglotRefund || isOnSiteRefund) && 'pb-[76px]'
      ])}
    >
      <Button
        text="앱 다운로드하기"
        background="bg010"
        color="text090"
        pyValue="py-[9px]"
        className="body-2 border border-030"
        onClick={handleClickAppDownload}
      />
      <div className="mt-6 flex flex-col gap-2">
        <Tint level="tint1" color="text070" weight="medium">
          (주) 쏘카
        </Tint>
        <Tint level="tint1" color="text070" weight="medium">
          통신판매업 신고: 제 2019-제주오라-3호
        </Tint>
        <Tint level="tint1" color="text070" weight="medium">
          사업자등록번호: 616-81-90529, 대표자: 박재욱
        </Tint>
        <Tint level="tint1" color="text070" weight="medium">
          전화번호: 1661-3315, Fax: 02-6969-9333
        </Tint>
        <Tint level="tint1" color="text070" weight="medium">
          주소: 제주특별자치도 제주시 연미길 42 (오라삼동)
        </Tint>
        <div className="flex items-center justify-start">
          <Link href={linkBaseUrl} target={'_blank'}>
            <Tint level="tint1" color="text070" style="underline" className="footer-terms">
              이용약관
            </Tint>
          </Link>
          <div className="mx-[8px] h-[8px] w-[1px] border-l border-[#6D7D90]" />
          <Link href={`${linkBaseUrl}/privacy`} target={'_blank'}>
            <Tint level="tint1" color="text070" style="underline" className="footer-terms">
              개인정보처리방침
            </Tint>
          </Link>
          <div className="mx-[8px] h-[8px] w-[1px] border-l border-[#6D7D90]" />
          <Link href={`${linkBaseUrl}/location`} target={'_blank'}>
            <Tint level="tint1" color="text070" style="underline" className="footer-terms">
              위치정보 이용약관
            </Tint>
          </Link>
          <div className="mx-[8px] h-[8px] w-[1px] border-l border-[#6D7D90]" />
          <Link href={userGuideURL} target={'_blank'}>
            <Tint level="tint1" color="text070" style="underline">
              고객센터
            </Tint>
          </Link>
        </div>
        <hr className="mt-1 border-030" />
      </div>
    </div>
  )
}

export default Footer
